import { render, staticRenderFns } from "./TestShortcuts.vue?vue&type=template&id=bf35a9e6&scoped=true&"
import script from "./TestShortcuts.vue?vue&type=script&lang=js&"
export * from "./TestShortcuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf35a9e6",
  null
  
)

export default component.exports